import React from 'react'
import { Link } from 'react-router-dom'

const MiniItem = ({Name,Image,Policiy}) => {
  return (
    <div className='sp_mini_item_wrapper'>
      <div className='sp_mini_item_container'>
        <Link to={'/policies/'+Policiy}>
            <img src={Image} alt='policiy'/>
            <h4>{Name}</h4>
        </Link>
      </div>
    </div>
  )
}

export default MiniItem
